import React from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import FormikControl from "../../../../../util/formcomponents/FormikControl";
import PrimaryButton from "../../../../../util/Btns/PrimaryButton";
import styles from "../styles.module.scss";

const INITIAL_VALUES = {
  title: "",
  appType: "3D",
  platform: "LITE",
  packageName: "",
  bundleID: "",
};
const AndroidApp = ({ configData, appType, onSubmit }) => {
  /**
   * SCHEMA VALIDATIONS
   */
  const validationSchemaCommon = Yup.object({
    title: Yup.string()
      .min(3, "Minimum 3 characters required")
      .required("Required")
      .matches(
        /^([A-Za-z0-9 ]*[A-Za-z]){3,}[A-Za-z0-9 '-]*$/,
        "Invalid Application name"
      ),
    packageName: Yup.string()
      .min(3, "Minimum 3 characters required")
      .required("Required")
      .matches(/^[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, `Invalid package name`),
  });
  return (
    <Formik
      initialValues={INITIAL_VALUES}
      validationSchema={validationSchemaCommon}
      onSubmit={onSubmit}
      validateOnChange
    >
      <Form>
        <div className={styles.new_project_body}>
          <FormikControl
            control="iconCheckbox"
            isRow={true}
            options={configData?.platform?.android}
            label="Select platform"
            name="platform"
            required
            handleModal={(e) => {
              e.preventDefault();
            }}
            handleChange={(e) => {
              e.preventDefault();
            }}
          />
          <FormikControl
            control="input"
            type="text"
            maxLen="30"
            label="Application Name"
            name="title"
          />
          <FormikControl
            control="radio"
            isRow={true}
            options={appType}
            label="Application Type"
            name="appType"
            required
          />
          <FormikControl
            control="input"
            type="text"
            maxLen="100"
            label="Package Name"
            name="packageName"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1em",
          }}
        >
          <PrimaryButton>Submit</PrimaryButton>
        </div>
      </Form>
    </Formik>
  );
};

export default AndroidApp;
